enum WizardConfigs {
  HOW_TO_PLAY = "HOW_TO_PLAY",
  SCANNING = "SCANNING",
  SCAN_TIMING = "SCAN_TIMING",
  FINAL_CHALLENGE = "FINAL_CHALLENGE",
  LEVEL_1_COMPLETE = "LEVEL_1_COMPLETE",
  LEVEL_2_WELCOME = "LEVEL_2_WELCOME",
  PROGRESSION = "PROGRESSION",
  BOOTCAMP_COMPLETE = "BOOTCAMP_COMPLETE",
  BOOTCAMP_COMPLETE_ALL_ACCESS = "BOOTCAMP_COMPLETE_ALL_ACCESS",
  AWARENESS = "AWARENESS",
  // Vision XR
  WELCOME_VISION_XR = "WELCOME_VISION_XR",
  PLUS_FEATURES_LIST = "PLUS_FEATURES_LIST",
  WELCOME_SURVEY = "WELCOME_SURVEY",
  WELCOME_WIZARD_VR = "WELCOME_WIZARD_VR",
  WELCOME_WIZARD_MOBILE = "WELCOME_WIZARD_MOBILE",
  WELCOME_WIZARD_DESKTOP = "WELCOME_WIZARD_DESKTOP",
};

export default WizardConfigs;